









































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Funcionalidades } from '@/config/funcionalidades';
import CabeceraModal from '@/reusable/Modal/CabeceraModal.vue';
import ModalMantenedor from '@/reusable/Modal/ModalMantenedor.vue';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';

import { actionsEvent } from '@/setup';
import { AlertaGrilla } from '@/pantallas/Camaras/Alertas/fetchAlerta';
import { LoadingService } from '@/services/loadingService';
import { Snotify } from '@/snotify/Snotify';
import { Validator } from 'vee-validate/types/vee-validate';
import Confirmation from '@/components/Confirmation.vue';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import TimePicker from '@/reusable/Form/TimePicker.vue';
import moment from 'moment';
import { fetchMS } from './fetchMS';
//import modalCREARDetalleAltaServicio from '@/pantallas/Conecta/AltasServicio/modal_crear_detalle_alta.vue';
import MantenedorGridSinCodigo from '@/reusable/Grid/MantenedorGridSinCodigo.vue';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import config from '@/config/index';
import {
  GridOptions,
  GridApi,
  ColumnApi,
  ColDef,
  GridReadyEvent,
  RowNode,
  DragStoppedEvent,
  ColumnVisibleEvent,
  ColumnPinnedEvent,
  ProcessCellForExportParams,
  CsvExportParams,
  ValueFormatterParams,
  ICellRendererParams,
  GetQuickFilterTextParams,
} from 'ag-grid-community';
import {
  checkboxColumnDef,
  makeAccionesColumnDef,
} from '@/reusable/Grid/aggridColumnDefUtils';
import {
  codigoAccionesMenuItem,
  CodigoAccion,
  PermisoAccion,
} from '@/views/base/VariablesPermisos';
import MantenedorGrid from '@/reusable/Grid/MantenedorGrid.vue';
import { Console } from 'console';

@Component({
  components: {
    CabeceraModal,
    ModalMantenedor,
    FormFieldsContainer,
    MantenedorGrid,
    DatePicker,
    MantenedorGridSinCodigo,
    'app-confirmacion': Confirmation,
  },
})
export default class ModalEditar extends Vue {
  //readonly funcionalidad: Funcionalidades =  Funcionalidades.SolicitudAnulacionVentaGRILLA;
  readonly $snotify: Snotify;
  @Prop({ default: true }) show: boolean;
  @Prop({ default: false }) dialog: boolean;
  @Prop({ default: null }) tabs: any;
  @Prop({ default: null }) IDVEHICULO: any;
  @Prop({ default: null }) LOGINCODE: any;
  @Prop({ default: null }) NOMFLOTA: any;
  @Prop({ default: null }) GRUPOVEHICULO: any;
  @Prop({ default: null }) PATENTE: any;
  @Prop({ default: null }) PLATAFORMA: any;

  gridApi: GridApi = null;
  model_id_vehiculo: any = null;
  model_login_code: any = null;
  model_nomflota: any = null;
  model_nomgrupovehiculo: any = null;
  model_plataforma: any = null;
  model_patente: any = null;
  accionesTotales: PermisoAccion[] = [];
  mostrarModalCONFIRMAR: boolean = false;
  Modal_confirmar_TEXTO: any = '';

  async confirmCallback(val: boolean) {
    if (val == true) {
      this.updatelogincode();
    } else {
      this.mostrarModalCONFIRMAR = false;
    }
  }

  async start_update_logincode() {
    if (this.model_login_code == null || this.model_login_code == '') {
      this.$snotify.error('Debe ingresar un login code');
      return;
    }
    // must be int
    if (!Number.isInteger(Number(this.model_login_code))) {
      this.$snotify.error('El login code debe ser un número entero');
      return;
    }
    this.Modal_confirmar_TEXTO =
      '¿Está seguro que desea agregar el login code ' +
      this.model_login_code +
      ' para vehículo de patente ' +
      this.model_patente +
      ' ?';
    this.mostrarModalCONFIRMAR = true;
  }

  async updatelogincode() {
    this.loadingService.showLoading(undefined, 'updatelogincode');
    return fetchMS(
      {
        cod_vehiculo: this.model_id_vehiculo,
        login_code: this.model_login_code,
        plataforma: this.PLATAFORMA,
      },
      'sitrack_logincode/updateLoginCode'
    )
      .then((data: any) => {
        this.loadingService.hideLoading('updatelogincode');
        if (data.data.STATUS == 'NOK') {
          this.$snotify.error(data.data.MENSAJE);
          return;
        }
        this.$snotify.success(data.data.MENSAJE);
        this.closeModal();
      })

      .catch((error: any) => {
        return null;
      })
      .finally(() => {
        return null;
      });
  }

  constructor() {
    super();
  }
  handleInfoGeneral() {
    this.showInfo = true;
  }

  pasoActivoIndex = 1;
  pasos = {
    informacionGeneral: {
      accion: 'Crear - Información General',
      visible: true,
      step: 1,
    },
  };

  showInfo: boolean = true;
  readonly loadingService = new LoadingService();

  async mounted() {
    this.model_id_vehiculo = this.IDVEHICULO;
    this.model_login_code = this.LOGINCODE;
    this.model_nomflota = this.NOMFLOTA;
    this.model_nomgrupovehiculo = this.GRUPOVEHICULO;
    this.model_patente = this.PATENTE;
  }

  getUserID(): any {
    let user = localStorage.getItem('user');
    let id = JSON.parse(user.replace(/'/g, '"')).id;
    return id;
  }

  closeModal() {
    this.$emit('modalverDetalleEmit', false);
  }

  getCliente() {
    let user = localStorage.getItem('user');
    let clienteDefecto = JSON.parse(
      localStorage.getItem('user').replace(/'/g, '"')
    ).clienteDefecto;
    return clienteDefecto;
  }
}
